/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-03-09 16:30:27
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-04-23 15:12:27
 */

import React from "react";
import { HashRouter as Router } from "react-router-dom";
//import { BrowserRouter as Router } from "react-router-dom";
import { renderRoutes } from "assets/renderRouter";
import Loadable from "react-loadable"; //按需加载路由插件
import { Provider } from "react-redux";
import { store } from "../tools/store";

const MyLoadingComponent = (v: { isLoading: any; error: any }) => {
  if (v.isLoading) {
    return <div>Loading...</div>;
  } else if (v.error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};
// 报错页
const Error = Loadable({
  loader: () => import("../views/error"),
  loading: MyLoadingComponent
});
// 摇一摇
const Landing = Loadable({
  loader: () => import("../views/shake/landing"),
  loading: MyLoadingComponent,
});
const Record = Loadable({
  loader: () => import("./shake/record"),
  loading: MyLoadingComponent,
});
const Rules = Loadable({
  loader: () => import("./shake/rules"),
  loading: MyLoadingComponent,
});
const routes = [
  {
    path: "/error", // 报错页
    component: Error
  },
  {
    path: "/landing", // 摇一摇首页
    component: Landing,
  },
  {
    path: "/record", // 摇一摇获奖记录页
    component: Record,
  },
  {
    path: "/rules", // 摇一摇规则
    component: Rules,
  },
  {
    path: "/",
    redirect: "/landing"
  }
];

const mRoute = () => {
  return (
    <Provider store={store}>
      <Router>{renderRoutes(routes)}</Router>
    </Provider>
  );
};

export default mRoute;
